<h1 matDialogTitle>Refund Deposit</h1>

<mat-dialog-content>


  <div>
    <table style="width: 100%;">
      <tr>
        <th class="th-label">Sales Order</th>
        <td class="td-value" style="text-align: right; padding-right: 16px;">{{salesOrder.erpSalesOrderNumber}}</td>
        <th class="th-label">Currency</th>
        <td class="td-value" style="text-align: right;">{{salesOrder.currencyName}}</td>
      </tr>
      <tr>
        <th class="th-label">Customer</th>
        <td class="td-value" style="text-align: right; padding-right: 16px;">{{salesOrder.customerCode}}</td>
        <th class="th-label">Customer Account</th>
        <td class="td-value" style="text-align: right;">{{salesOrder.customerAccountBalance | number:'1.2-2'}}</td>
      </tr>
      <tr>
        <th class="th-label">Order Amount</th>
        <td class="td-value" style="text-align: right; padding-right: 16px;">{{salesOrder.totalAmount | number:'1.2-2'}}</td>
        <th class="th-label">Deposit Received</th>
        <td class="td-value" style="text-align: right;">{{salesOrder.depositReceived | number:'1.2-2' : ''}}
        </td>
      </tr>
      <tr>
        <th class="th-label">Deposit Required</th>
        <td class="td-value" style="text-align: right; padding-right: 16px;">{{salesOrder.depositRequired | number:'1.2-2'}}</td>
        <th class="th-label">Deposit Outstanding</th>
        <td class="td-value" style="text-align: right;">{{salesOrder.depositOutstanding | number:'1.2-2' : ''}}
        </td>
      </tr>
    </table>
  </div>
  <app-pos-capture-payment (paymentChanged)="paymentChanged($event)" (refundReasonChanged)="refundReasonChanged($event)" [paymentType]="'DEPOSIT-REFUND'" [amountOutstanding]="salesOrder.depositOutstanding * -1" [salesOrderNumber]="salesOrder.erpSalesOrderNumber"></app-pos-capture-payment>

  <ng-container *ngIf="busy">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions>
  <button [disabled]="busy" mat-button matDialogClose>Cancel</button>
  <button [disabled]="!formValid || busy || !refundReasonId" mat-button (click)="save()">Save</button>
</mat-dialog-actions>
